"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_query_1 = require("react-query");
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("./app"));
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
var Index = function () {
    var _a;
    var bgColor = (_a = window.ingredientsApp) === null || _a === void 0 ? void 0 : _a.backgroundColor;
    var selectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.variant; });
    return (react_1.default.createElement("div", { className: "bg-".concat(bgColor ? bgColor : 'white') },
        react_1.default.createElement("div", { id: 'ingredients', className: 'header-anchor-adjust' }),
        react_1.default.createElement("div", { className: 'grid-container padding-horizontal-6 padding-vertical-15 medium-padding-vertical-25' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'h3 font-bold' }, "Ingredients"),
                react_1.default.createElement("div", { className: 'margin-vertical-5 medium-margin-vertical-8 font-lighter', style: { maxWidth: '475px' } }, "We want you to know what we're made of. Click on each ingredient to learn more.")),
            react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
                react_1.default.createElement(app_1.default.Table, { variant: selectedVariant })),
            react_1.default.createElement(app_1.default.Tag, { className: 'text-cornflower-lilac show-for-medium margin-top-8' }))));
};
(0, render_app_1.default)('ingredients-app', function () { return react_1.default.createElement(Index, null); });
